import axios from 'axios';
import {getApiBaseUrl} from '../utils/getApiBaseUrl';
import secureStorage from "../utils/secureStorage";

const API_URL = getApiBaseUrl();

const api = axios.create({
  baseURL: API_URL,
});

api.interceptors.request.use(
  (config) => {
    // Obtener el token del localStorage
    const token = secureStorage.getItem('authToken');
    
    if (token) {
      // Agregar el token al encabezado de autorización
      config.headers['Authorization'] = `Bearer ${token}`;
    }

    return config;
  },
  (error) => Promise.reject(error)
);

export const getFeriados = async () => {
  try {
    const response = await api.get(`feriados`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postFeriado = async (feriado) => {
  try {
    const response = await api.post(`feriados`, feriado);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateFeriado = async (id, feriado) => {
  try {
    const response = await api.put(`feriados/${id}`, feriado);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const desactivarFeriado = async (id) => {
  try {
    const response = await axios.patch(`${API_URL}/feriados/${id}/desactivar`, {
      status_active: 0
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};